import { render, staticRenderFns } from "./WordEditor.vue?vue&type=template&id=2eba5b69&scoped=true"
import script from "./WordEditor.vue?vue&type=script&lang=js"
export * from "./WordEditor.vue?vue&type=script&lang=js"
import style0 from "./WordEditor.vue?vue&type=style&index=0&id=2eba5b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba5b69",
  null
  
)

export default component.exports